import { jsx as _jsx } from "react/jsx-runtime";
import PaginationMUI from '@mui/material/Pagination';
export const Pagination = ({ count, page, onChange, rowsPerPage = 20, hidePrevButton, hideNextButton, className, }) => {
    const onPageChange = (event, pageNumber) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(pageNumber - 1);
    };
    return (_jsx(PaginationMUI, { className: className, count: Math.ceil(count / rowsPerPage), page: page + 1, shape: "rounded", onChange: onPageChange, hidePrevButton: hidePrevButton, hideNextButton: hideNextButton, size: "small", "data-testid": "table-pagination" }));
};
export default Pagination;
